export default {
  selectPreset: 'Select a preset',
  resetPreset: 'Reset preset changes',
};
